<template>
    <b-card no-body>
        <div class="card-body">
            <div class="row">
                <div class="col-md-8">
                    <b-card no-body class="mb-2 border">
                        <div class="card-header">
                            <h4 class="card-title">Yakıt Tedarikçisi & Sipariş</h4>
                        </div>
                        <div class="card-body">
                            <b-overlay :show="loading" rounded="sm">
                                <div class="row">
                                    <div class="col-12 mb-1">
                                        <b-form-group label="Ana Sipariş Seçimi" class="is-required">
                                            <v-validator :errors="errors" parameter="orderId" :watch="form.orderId">
                                                <v-select-list v-model="form.orderId" :options="fuelOrderOptions" label="displayText" :reduce="(order) => order.Id" placeholder="İlgili siparişi seçiniz..." v-on:input="onOrderSelect" :disabled="!!$route.params.id" />
                                            </v-validator>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-6">
                                        <b-form-group label="Tedarikçi">
                                            <b-form-input :value="selectedOrder.supplierName" disabled />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group label="Dağıtım Merkezi">
                                            <b-form-input :value="form.driver.destinationLocation" disabled />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-12">
                                        <b-form-group label="Tedarikçi Konumu" class="is-required">
                                            <v-validator :errors="errors" parameter="supplier.locationId" :watch="form.supplier.locationId">
                                                <v-select-list v-model="form.supplier.locationId" :options="supplierLocations" label="LocationName" :reduce="(loc) => loc.Id" placeholder="Konum seçiniz..." :disabled="!form.orderId || locationsLoading" :loading="locationsLoading" />
                                            </v-validator>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-12" v-if="form.supplier.locationAddress">
                                        <b-form-group label="Tedarikçi Adresi">
                                            <b-form-textarea :value="form.supplier.locationAddress" disabled rows="3" no-resize />
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-3">
                                        <b-form-group label="Firma Sipariş No"><b-form-input :value="selectedOrder.orderNumber" disabled /></b-form-group>
                                    </div>
                                    <div class="col-md-3">
                                        <b-form-group label="Tedarikçi Sipariş No"><b-form-input v-model="form.supplier.orderNumber" :disabled="!form.orderId" /></b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group label="Ürün"><b-form-input :value="selectedOrder.fuelTypeName" disabled /></b-form-group>
                                    </div>
                                    <div class="col-md-3">
                                        <b-form-group label="Birim Fiyat">
                                            <b-form-input :value="(selectedOrder.unitPrice || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3">
                                        <b-form-group label="Taşıma Maliyeti">
                                            <b-form-input :value="(selectedOrder.transportAmount || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3">
                                        <b-form-group label="Vade (Gün)">
                                            <b-form-input :value="selectedOrder.vade" disabled />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3">
                                        <b-form-group label="Sipariş Tutarı">
                                            <b-form-input :value="selectedOrderTotalAmount" disabled />
                                        </b-form-group>
                                    </div>
                                </div>
                            </b-overlay>
                        </div>
                    </b-card>

                    <b-card title="Araç & Sürücü" class="mb-2 border">
                        <b-overlay :show="loading" rounded="sm">
                            <div class="row">
                                <!-- AdBlue Değilse (Motorin): Mevcut disabled inputlar -->
                                <template v-if="!isAdBlue">
                                    <div class="col-md-6">
                                        <b-form-group label="Çekici Plaka">
                                            <b-form-input :value="selectedOrder.vehiclePlate" disabled />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group label="Treyler Plaka">
                                            <b-form-input :value="selectedOrder.trailerPlate" disabled />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group label="Sürücü">
                                            <b-form-input :value="selectedOrder.driverEmployee" disabled />
                                        </b-form-group>
                                    </div>
                                </template>

                                <!-- AdBlue ise: Editable Select Listeler -->
                                <template v-else>
                                    <div class="col-md-6">
                                        <b-form-group label="Çekici Plaka" class="is-required">
                                            <v-validator :errors="errors" parameter="adblueCarrier.vehiclePlate" :watch="form.adblueCarrier.vehiclePlate">
                                                <v-select-list v-model="form.adblueCarrier.vehiclePlate" :options="truckPlates" label="PlateValue" :reduce="(plate) => plate.PlateValue" placeholder="Plaka seçiniz..." :disabled="!form.orderId" />
                                            </v-validator>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group label="Treyler Plaka">
                                            <v-select-list v-model="form.adblueCarrier.trailerPlate" :options="trailerPlates" label="PlateValue" :reduce="(plate) => plate.PlateValue" placeholder="Treyler plakası seçiniz..." :disabled="!form.orderId" />
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group label="Sürücü" class="is-required">
                                            <v-validator :errors="errors" parameter="adblueCarrier.fullName" :watch="form.adblueCarrier.fullName">
                                                <v-select-list v-model="form.adblueCarrier.fullName" :options="employees" label="FullName" :reduce="(emp) => emp.FullName" v-on:search="searchEmployees" placeholder="Sürücü adı girin…" :loading="employeeLoading" :disabled="!form.orderId" />
                                            </v-validator>
                                            <div v-if="selectedEmployeeTckn" class="mt-25 ml-50">
                                                <small class="text-muted">
                                                    <feather-icon icon="UserCheckIcon" size="12" class="mr-50" />
                                                    TCKN: <strong>{{ selectedEmployeeTckn }}</strong>
                                                </small>
                                            </div>
                                        </b-form-group>
                                    </div>
                                </template>

                                <!-- Gideceği Yer her iki durumda da aynı kalır -->
                                <div class="col-md-6">
                                    <b-form-group label="Gideceği Yer (Şube)">
                                        <b-form-input v-model="form.driver.destinationLocation" disabled />
                                    </b-form-group>
                                </div>
                            </div>
                        </b-overlay>
                    </b-card>

                    <b-card title="Kantar Ölçümü #1" class="mb-2 border">
                        <weighing-card v-model="form.weighing1" :initial-firm-name="weighingFirm1Name" :density="form.analysis.density" :disabled="!form.orderId" :errors="errors" :order-date="selectedOrder.orderDate" error-prefix="weighing1" />
                    </b-card>

                    <b-card no-body class="mb-2 border">
                        <div v-b-toggle.collapse-weighing-2 class="card-header d-flex justify-content-between align-items-center cursor-pointer">
                            <h4 class="card-title mb-0">Kantar Ölçümü #2 (opsiyonel)</h4>
                            <feather-icon :icon="isWeighing2Visible ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="18" />
                        </div>
                        <b-collapse id="collapse-weighing-2" v-model="isWeighing2Visible">
                            <div class="card-body">
                                <weighing-card v-model="form.weighing2" :initial-firm-name="weighingFirm2Name" :density="form.analysis.density" :disabled="!form.orderId" :errors="errors" error-prefix="weighing2" :order-date="selectedOrder.orderDate" />
                            </div>
                        </b-collapse>
                    </b-card>

                    <b-card title="Laboratuvar Ölçüm (TS EN 590)" class="mb-2 border">
                        <div class="row">
                            <b-form-group class="col-6" label="Sıcaklık (°C)">
                                <VCurrencyInput :value="form.analysis.temperature" @update-value="(newValue) => (form.analysis.temperature = newValue)" :disabled="!form.orderId" placeholder="0" />
                            </b-form-group>
                            <b-form-group label="Yoğunluk @15°C (kg/lt)" class="col-6 is-required">
                                <v-validator :errors="errors" parameter="analysis.density" :watch="form.analysis.density">
                                    <b-form-input id="density-input" :value="displayValues.density" @input="(val) => (displayValues.density = val)" @focus="onDensityFocus" @blur="onDensityBlur" @keypress.enter="onDensityBlur" :disabled="!form.orderId" />
                                </v-validator>
                            </b-form-group>
                            <b-form-group label="Setan Sayısı" class="col-6">
                                <VCurrencyInput :value="form.analysis.setan" @update-value="(newValue) => (form.analysis.setan = newValue)" :disabled="!form.orderId" />
                            </b-form-group>
                            <b-form-group label="Kükürt (mg/kg)" class="col-6">
                                <VCurrencyInput :value="form.analysis.sulfur" @update-value="(newValue) => (form.analysis.sulfur = newValue)" :disabled="!form.orderId" />
                            </b-form-group>
                            <b-form-group label="FAME (%)" class="col-6">
                                <VCurrencyInput :value="form.analysis.fame" @update-value="(newValue) => (form.analysis.fame = newValue)" :disabled="!form.orderId" />
                            </b-form-group>
                            <b-form-group label="Parlama Noktası (°C)" class="col-6">
                                <VCurrencyInput :value="form.analysis.flashPoint" @update-value="(newValue) => (form.analysis.flashPoint = newValue)" :disabled="!form.orderId" />
                            </b-form-group>
                            <div class="col-md-12">
                                <b-form-group label="Analiz Raporu Dosyası">
                                    <v-file-uploader :value="form.analysis.file" @change="(val) => (form.analysis.file = val)" :accept="['png', 'jpg', 'jpeg', 'pdf']" :disabled="!form.orderId" />
                                </b-form-group>
                            </div>
                        </div>
                    </b-card>

                    <b-card title="Yakıt Dağıtım & Teslimat Bilgileri" class="mb-2 border">
                        <div v-if="transactionDetails.length > 0">
                            <h6 class="mb-1 text-muted">Bu Siparişe Bağlı Gerçekleşen Depo Dolumları</h6>

                            <div v-for="transaction in transactionDetails" :key="transaction.Id" class="border rounded p-1 mt-75">
                                <div class="d-flex justify-content-between align-items-center bg-light p-1 mb-1 rounded">
                                    <span class="font-weight-bold">
                                        <feather-icon icon="CheckCircleIcon" size="16" class="mr-50" />
                                        İşlem No: {{ transaction.ProcessNumber }}
                                    </span>
                                    <span v-if="transaction.FuelStorageInputTransactionDetails.length > 0">
                                        <feather-icon icon="UserIcon" size="16" class="mr-50" />
                                        {{ getEmployeeName(transaction.FuelStorageInputTransactionDetails[0].DriverEmployeeId) }}
                                    </span>
                                    <span v-if="transaction.FuelStorageInputTransactionDetails.length > 0">
                                        <feather-icon icon="TruckIcon" size="16" class="mr-50" />
                                        {{ getPlateValue(transaction.FuelStorageInputTransactionDetails[0].VehiclePlateId) }}
                                    </span>
                                </div>

                                <table class="table table-sm table-bordered table-striped w-100 mb-0">
                                    <thead>
                                        <tr>
                                            <th style="width: 50%"><feather-icon icon="DatabaseIcon" size="16" class="mr-50" /> Depo</th>
                                            <th style="width: 30%"><feather-icon icon="UserCheckIcon" size="16" class="mr-50" /> Teslim Alan</th>
                                            <th class="text-right" style="width: 20%"><feather-icon icon="TrendingUpIcon" size="16" class="mr-50" /> Miktar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="detail in transaction.FuelStorageInputTransactionDetails" :key="detail.Id">
                                            <td>{{ detail.FuelStorageVisibleName }}</td>
                                            <td>{{ getEmployeeName(detail.ReceivingEmployeeId) }}</td>
                                            <td class="text-right">
                                                <b-badge variant="light-success" class="font-weight-bold">{{ detail.QuantityStr }} lt</b-badge>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- <hr class="mb-1" /> -->
                        </div>
                    </b-card>
                    <b-card title="e-İrsaliye/Taşıma Bilgileri" class="mb-2 border">
                        <div class="row">
                            <div class="col-md-4">
                                <b-form-group label="e-İrsaliye No" class="is-required">
                                    <v-validator :errors="errors" parameter="eWaybill.number" :watch="form.eWaybill.number">
                                        <b-form-input v-model="form.eWaybill.number" :disabled="!form.orderId" />
                                    </v-validator>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="İrsaliye Tarihi" class="is-required">
                                    <v-validator :errors="errors" parameter="eWaybill.date" :watch="form.eWaybill.date">
                                        <v-date-picker v-model="form.eWaybill.date" placeholder="Tarih seçin" :disabled="!form.orderId" style="width: 100%" />
                                    </v-validator>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Sevk Zamanı" class="is-required">
                                    <v-validator :errors="errors" parameter="eWaybill.dispatchTime" :watch="form.eWaybill.dispatchTime">
                                        <v-date-picker v-model="form.eWaybill.dispatchTime" type="datetime" for-back placeholder="Tarih ve saat seçin" :disabled="!form.orderId" :disabled-date="disableDispatchDates" :disabled-time="disableDispatchTimes" style="width: 100%" />
                                    </v-validator>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Şahit Numune Seri No"><b-form-input v-model="form.eWaybill.witnessSampleSerialNo" :disabled="!form.orderId" /></b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Miktar (lt)" class="is-required">
                                    <v-validator :errors="errors" parameter="eWaybill.ltValue" :watch="form.eWaybill.ltValue">
                                        <VCurrencyInput :value="form.eWaybill.ltValue" @update-value="(newValue) => (form.eWaybill.ltValue = newValue)" :disabled="!form.orderId" placeholder="0" />
                                    </v-validator>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Miktar (kg)">
                                    <VCurrencyInput :value="form.eWaybill.kgValue" @update-value="(newValue) => (form.eWaybill.kgValue = newValue)" :disabled="!form.orderId" placeholder="0" />
                                </b-form-group>
                            </div>
                            <div class="col-md-12">
                                <b-form-group label="Mühür Numaraları (Virgülle ayırarak girin)">
                                    <b-form-textarea v-model="form.eWaybill.sealNumbers" :disabled="!form.orderId" rows="2" />
                                </b-form-group>
                            </div>
                            <div class="col-md-12">
                                <b-form-group label="e-İrsaliye Dosyası">
                                    <v-file-uploader :value="form.eWaybill.file" @change="(val) => (form.eWaybill.file = val)" :accept="['png', 'jpg', 'jpeg', 'pdf']" :disabled="!form.orderId" />
                                </b-form-group>
                            </div>
                        </div>
                    </b-card>

                    <b-card title="Teslim Tesellüm Tutanağı" class="mb-2 border">
                        <div class="row">
                            <div class="col-md-4">
                                <b-form-group label="Sipariş No"><b-form-input :value="selectedOrder.orderNumber" disabled /></b-form-group>
                            </div>
                            <div class="col-md-8">
                                <b-form-group label="Teslimat Zamanı" class="is-required">
                                    <v-validator :errors="errors" parameter="deliveryReceipt.reportDeliveryDate" :watch="form.deliveryReceipt.reportDeliveryDate">
                                        <v-date-picker
                                            v-model="form.deliveryReceipt.reportDeliveryDate"
                                            type="datetime"
                                            for-back
                                            :placeholder="reportDeliveryDatePlaceholder"
                                            :disabled="!form.orderId || !form.eWaybill.dispatchTime"
                                            :disabled-date="disableReportDeliveryDates"
                                            :disabled-time="disableReportDeliveryTimes"
                                            style="width: 100%"
                                        />
                                    </v-validator>
                                </b-form-group>
                            </div>
                            <div class="col-md-12">
                                <b-form-group label="Şube Adı"><b-form-input :value="form.driver.destinationLocation" disabled /></b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Çekici Plaka">
                                    <b-form-input :value="isAdBlue ? form.adblueCarrier.vehiclePlate : selectedOrder.vehiclePlate" disabled />
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Treyler Plaka">
                                    <b-form-input :value="isAdBlue ? form.adblueCarrier.trailerPlate || '-' : selectedOrder.trailerPlate" disabled />
                                </b-form-group>
                            </div>
                            <div class="col-md-12">
                                <b-form-group label="Sürücü">
                                    <b-form-input :value="isAdBlue ? form.adblueCarrier.fullName : selectedOrder.driverEmployee" disabled />
                                </b-form-group>
                            </div>
                        </div>
                    </b-card>
                </div>

                <div class="col-md-4">
                    <b-card title="Özet & Ayarlar" class="mb-2 border sticky-top">
                        <div class="row">
                            <b-form-group label="Yoğunluk @15°C (kg/lt)" class="col-6">
                                <b-form-input :value="(form.analysis.density || 0).toLocaleString('tr-TR')" disabled class="text-center font-weight-bold" />
                            </b-form-group>
                            <b-form-group label="Talep (Net @15°C lt)" class="col-6">
                                <b-form-input :value="(selectedOrder.orderQuantity || 0).toLocaleString('tr-TR')" disabled class="text-center font-weight-bold" />
                            </b-form-group>

                            <div class="col-6 mb-1">
                                <div class="summary-box-primary">
                                    <span>Belge Net @15°C (lt)</span>
                                    <strong>{{ summaryDocumentNetL.toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>
                            <div class="col-6 mb-1">
                                <div class="summary-box-primary">
                                    <span>Belge Net (kg)</span>
                                    <strong>{{ summaryDocumentNetKg.toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="summary-box-primary" :class="demandVsDeliveryDiffClass">
                                    <span>Talep - Teslim Farkı</span>
                                    <strong class="text-white"> {{ summaryDemandVsDeliveryDiffL.toLocaleString("tr-TR") }} lt ({{ summaryDemandVsDeliveryDiffPercent.toFixed(2) }}%) </strong>
                                </div>
                            </div>
                        </div>
                    </b-card>

                    <b-card title="Tutarlılık Panosu" class="mb-2 border sticky-top">
                        <div class="row">
                            <div class="col-6 mb-1">
                                <div class="summary-box-secondary">
                                    <span>Kantar 1 Net (lt)</span><strong>{{ consistencyWeighing1NetVolume.toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>
                            <div v-if="isWeighing2Entered" class="col-6 mb-1">
                                <div class="summary-box-secondary">
                                    <span>Kantar 2 Net (lt)</span><strong>{{ consistencyWeighing2NetVolume.toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>
                            <div class="col-6 mb-1">
                                <div class="summary-box-secondary">
                                    <span>İrsaliye Net (lt)</span><strong>{{ (form.eWaybill.ltValue || 0).toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>
                            <div class="col-6 mb-1">
                                <div class="summary-box-secondary">
                                    <span>Toplam Sayaç (lt)</span><strong>{{ (totalDistributedQuantity || 0).toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>
                            <div class="col-6 mb-1">
                                <div class="summary-box-secondary">
                                    <span>Sipariş (lt)</span><strong>{{ (selectedOrder.orderQuantity || 0).toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>

                            <div class="col-12"><hr class="my-1" /></div>
                            <div class="col-6 mb-1">
                                <div class="summary-box-primary" :class="consistencyOrderVsEwaybillDiffL !== 0 ? 'summary-box-danger' : 'summary-box-success'">
                                    <span>Sipariş - İrsaliye Fark (lt)</span><strong class="text-white">{{ consistencyOrderVsEwaybillDiffL.toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>
                            <div class="col-6 mb-1">
                                <div class="summary-box-primary" :class="consistencyOrderVsEwaybillDiffKg !== 0 ? 'summary-box-danger' : 'summary-box-success'">
                                    <span>Sipariş - İrsaliye Fark (kg)</span><strong class="text-white">{{ consistencyOrderVsEwaybillDiffKg.toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>

                            <div class="col-12"><hr class="my-1" /></div>

                            <div class="col-6 mb-1">
                                <div class="summary-box-primary" :class="consistencyOrderVsWeighing1DiffL !== 0 ? 'summary-box-danger' : 'summary-box-success'">
                                    <span>Sipariş - K1 Fark (lt)</span><strong class="text-white">{{ consistencyOrderVsWeighing1DiffL.toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>
                            <div class="col-6 mb-1">
                                <div class="summary-box-primary" :class="consistencyOrderVsWeighing1DiffKg !== 0 ? 'summary-box-danger' : 'summary-box-success'">
                                    <span>Sipariş - K1 Fark (kg)</span><strong class="text-white">{{ consistencyOrderVsWeighing1DiffKg.toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>

                            <div class="col-6 mb-1">
                                <div class="summary-box-primary" :class="consistencyWeighing1VsEwaybillDiffL !== 0 ? 'summary-box-danger' : 'summary-box-success'">
                                    <span>Kantar 1 - İrsaliye Fark (lt)</span><strong class="text-white">{{ consistencyWeighing1VsEwaybillDiffL.toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>
                            <div class="col-6 mb-1">
                                <div class="summary-box-primary" :class="consistencyWeighing1VsEwaybillDiffKg !== 0 ? 'summary-box-danger' : 'summary-box-success'">
                                    <span>Kantar 1 - İrsaliye Fark (kg)</span><strong class="text-white">{{ consistencyWeighing1VsEwaybillDiffKg.toLocaleString("tr-TR") }}</strong>
                                </div>
                            </div>

                            <template v-if="isWeighing2Entered">
                                <div class="col-12"><hr class="my-1" /></div>
                                <div class="col-6 mb-1">
                                    <div class="summary-box-primary" :class="consistencyOrderVsWeighing2DiffL !== 0 ? 'summary-box-danger' : 'summary-box-success'">
                                        <span>Sipariş - K2 Fark (lt)</span><strong class="text-white">{{ consistencyOrderVsWeighing2DiffL.toLocaleString("tr-TR") }}</strong>
                                    </div>
                                </div>
                                <div class="col-6 mb-1">
                                    <div class="summary-box-primary" :class="consistencyOrderVsWeighing2DiffKg !== 0 ? 'summary-box-danger' : 'summary-box-success'">
                                        <span>Sipariş - K2 Fark (kg)</span><strong class="text-white">{{ consistencyOrderVsWeighing2DiffKg.toLocaleString("tr-TR") }}</strong>
                                    </div>
                                </div>

                                <div class="col-6 mb-1">
                                    <div class="summary-box-primary" :class="consistencyWeighing2VsEwaybillDiffL !== 0 ? 'summary-box-danger' : 'summary-box-success'">
                                        <span>Kantar 2 - İrsaliye Fark (lt)</span><strong class="text-white">{{ consistencyWeighing2VsEwaybillDiffL.toLocaleString("tr-TR") }}</strong>
                                    </div>
                                </div>
                                <div class="col-6 mb-1">
                                    <div class="summary-box-primary" :class="consistencyWeighing2VsEwaybillDiffKg !== 0 ? 'summary-box-danger' : 'summary-box-success'">
                                        <span>Kantar 2 - İrsaliye Fark (kg)</span><strong class="text-white">{{ consistencyWeighing2VsEwaybillDiffKg.toLocaleString("tr-TR") }}</strong>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </b-card>
                </div>
            </div>

            <div class="row">
                <div class="col-12 text-right mt-2">
                    <b-button variant="primary" v-on:click="save" :disabled="loading">
                        <b-spinner v-if="loading" small />
                        Kaydet
                    </b-button>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
import { BCard, BFormGroup, BFormInput, BOverlay, BBadge, BFormTextarea, BCollapse, BButton, BSpinner } from "bootstrap-vue";
import VValidator from "@/components/VValidator.vue";
import { VBToggle } from "bootstrap-vue";
import FuelStorageApi from "@/api/fuel-storage";
import EmployeeOperationsApi from "@/api/employee-operations";
import WeighingCard from "./components/WeighingCard.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import UserApi from "@/api/user";
import FirmOperationsApi from "@/api/firm-operations";
import VehicleOperationsApi from "@/api/vehicle-operations";
import VCurrencyInput from "@/components/VCurrencyInput.vue";
import VFileUploader from "@/components/v-file-uploader/VFileUploader.vue";

const getInitialFormData = () => ({
    id: null,
    orderId: null,
    supplier: {
        orderNumber: "",
        firmId: null,
        locationId: null,
        locationAddress: "",
    },

    adblueCarrier: {
        fullName: "",
        vehiclePlate: null,
        trailerPlate: null,
    },

    driver: {
        destinationLocation: "",
    },

    weighing1: {
        firmId: null,
        documentNumber: "",
        startDate: null,
        endDate: null,
        timeZone: "Europe/Istanbul",
        weightValue1: null,
        weightValue2: null,
        file: null,
    },

    weighing2: {
        firmId: null,
        documentNumber: "",
        startDate: null,
        endDate: null,
        timeZone: "Europe/Istanbul",
        weightValue1: null,
        weightValue2: null,
        file: null,
    },

    deliverySlip: {
        tankNumber: "",
        slipOrder: "",
        slipTime: null,
        counterOpening: 0,
        counterClosing: 0,
        additiveValue: 0,
    },

    eWaybill: {
        number: "",
        date: null,
        dispatchTime: null,
        ltValue: 0,
        kgValue: 0,
        sealNumbers: "",
        witnessSampleSerialNo: "",
        file: null,
    },

    deliveryReceipt: {
        file: null,
    },

    // analysis: {
    //     temperature: null,
    //     density: 0.8292,
    //     setan: 52.5,
    //     sulfur: 6.7,
    //     fame: 0.2,
    //     flashPoint: 63,
    // },

    analysis: {
        temperature: null,
        density: null,
        setan: null,
        sulfur: null,
        fame: null,
        flashPoint: null,
        file: null,
    },
});

export default {
    name: "FuelFillingForm",
    components: {
        BCard,
        BFormGroup,
        BFormInput,
        BOverlay,
        WeighingCard,
        BBadge,
        BFormTextarea,
        BCollapse,
        BButton,
        BSpinner,
        VValidator,
        VCurrencyInput,
        VFileUploader,
    },
    directives: {
        "b-toggle": VBToggle,
    },
    data() {
        return {
            form: getInitialFormData(),
            editing: false,
            documentDetailId: null,
            loading: false,
            fuelOrderOptions: [],
            selectedOrder: { orderDate: null },
            fuelStorageOptions: [],
            allEmployees: [],
            isWeighing2Visible: false,
            supplierLocations: [],
            locationsLoading: false,
            transactionDetails: [],
            allPlates: [],
            weighingFirm1Name: "",
            weighingFirm2Name: "",
            errors: {},
            displayValues: {
                density: "0,0000",
            },
            truckPlates: [],
            trailerPlates: [],
            employees: [],
            employeeLoading: false,
        };
    },
    watch: {
        "form.supplier.locationId"(newValue) {
            if (newValue) {
                const selectedLocation = this.supplierLocations.find((loc) => loc.Id === newValue);
                this.form.supplier.locationAddress = selectedLocation ? selectedLocation.Address : "";
            } else {
                this.form.supplier.locationAddress = "";
            }
        },
        "form.analysis.density"(newValue) {
            if (document.activeElement?.id !== "density-input") {
                this.displayValues.density = this.formatDensity(newValue);
            }
        },
    },
    mounted() {
        this.initializePage();
        this.displayValues.density = this.formatDensity(this.form.analysis.density);
        this.getTruckPlates();
        this.getTrailerPlates();
    },

    computed: {
        selectedOrderTotalAmount() {
            const qty = this.selectedOrder.orderQuantity || 0;
            const price = this.selectedOrder.unitPrice || 0;
            return (qty * price).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        reportDeliveryDatePlaceholder() {
            if (!this.form.eWaybill.dispatchTime) {
                return "Önce e-İrsaliye Sevk Zamanı giriniz";
            }
            return "Tarih ve saat seçin";
        },

        summaryDocumentNetL() {
            return this.selectedOrder.orderQuantity || 0;
        },
        summaryDocumentNetKg() {
            const density = this.form.analysis.density || 0;
            return this.summaryDocumentNetL * density;
        },
        summaryDemandVsDeliveryDiffL() {
            const demand = this.selectedOrder.orderQuantity || 0;
            const delivery = this.form.eWaybill.ltValue || 0;
            return demand - delivery;
        },
        summaryDemandVsDeliveryDiffPercent() {
            const demand = this.selectedOrder.orderQuantity || 0;
            if (demand === 0) return 0;
            return (this.summaryDemandVsDeliveryDiffL / demand) * 100;
        },
        demandVsDeliveryDiffClass() {
            const diff = this.summaryDemandVsDeliveryDiffL;
            if (diff === 0) return "summary-box-success";
            return "summary-box-danger";
        },
        totalDistributedQuantity() {
            if (!this.form || !this.form.distributions) return 0;
            return this.form.distributions.reduce((sum, dist) => {
                const quantityForRow = (Number(dist.counterClosing) || 0) - (Number(dist.counterOpening) || 0);
                return sum + quantityForRow;
            }, 0);
        },
        isWeighing2Entered() {
            return (this.form.weighing2.weightValue1 || 0) > 0 && (this.form.weighing2.weightValue2 || 0) > 0;
        },
        consistencyWeighing1NetKg() {
            const w1 = this.form.weighing1.weightValue1 || 0;
            const w2 = this.form.weighing1.weightValue2 || 0;
            return parseFloat((w1 - w2).toFixed(2));
        },
        consistencyWeighing1NetVolume() {
            const density = this.form.analysis.density || 0;
            if (density === 0) return 0;
            return parseFloat((this.consistencyWeighing1NetKg / density).toFixed(2));
        },
        consistencyWeighing2NetKg() {
            const w1 = this.form.weighing2.weightValue1 || 0;
            const w2 = this.form.weighing2.weightValue2 || 0;
            return parseFloat((w1 - w2).toFixed(2));
        },
        consistencyWeighing2NetVolume() {
            const density = this.form.analysis.density || 0;
            if (density === 0) return 0;
            return parseFloat((this.consistencyWeighing2NetKg / density).toFixed(2));
        },
        consistencyOrderVsWeighing1DiffL() {
            return parseFloat(((this.selectedOrder.orderQuantity || 0) - this.consistencyWeighing1NetVolume).toFixed(2));
        },
        consistencyOrderVsWeighing1DiffKg() {
            const orderKg = (this.selectedOrder.orderQuantity || 0) * (this.form.analysis.density || 0);
            return parseFloat((orderKg - this.consistencyWeighing1NetKg).toFixed(2));
        },
        consistencyOrderVsWeighing2DiffL() {
            return parseFloat(((this.selectedOrder.orderQuantity || 0) - this.consistencyWeighing2NetVolume).toFixed(2));
        },
        consistencyOrderVsWeighing2DiffKg() {
            const orderKg = (this.selectedOrder.orderQuantity || 0) * (this.form.analysis.density || 0);
            return parseFloat((orderKg - this.consistencyWeighing2NetKg).toFixed(2));
        },
        consistencyOrderVsEwaybillDiffL() {
            const orderL = this.selectedOrder.orderQuantity || 0;
            const ewaybillL = this.form.eWaybill.ltValue || 0;
            return parseFloat((orderL - ewaybillL).toFixed(2));
        },
        consistencyOrderVsEwaybillDiffKg() {
            const orderKg = (this.selectedOrder.orderQuantity || 0) * (this.form.analysis.density || 0);
            const ewaybillKg = this.form.eWaybill.kgValue || 0;
            return parseFloat((orderKg - ewaybillKg).toFixed(2));
        },
        consistencyWeighing1VsEwaybillDiffL() {
            const ewaybillL = this.form.eWaybill.ltValue || 0;
            return parseFloat((this.consistencyWeighing1NetVolume - ewaybillL).toFixed(2));
        },
        consistencyWeighing1VsEwaybillDiffKg() {
            const ewaybillKg = this.form.eWaybill.kgValue || 0;
            return parseFloat((this.consistencyWeighing1NetKg - ewaybillKg).toFixed(2));
        },
        consistencyWeighing2VsEwaybillDiffL() {
            const ewaybillL = this.form.eWaybill.ltValue || 0;
            return parseFloat((this.consistencyWeighing2NetVolume - ewaybillL).toFixed(2));
        },
        consistencyWeighing2VsEwaybillDiffKg() {
            const ewaybillKg = this.form.eWaybill.kgValue || 0;
            return parseFloat((this.consistencyWeighing2NetKg - ewaybillKg).toFixed(2));
        },
        isAdBlue() {
            const fuelType = this.selectedOrder.fuelTypeName || "";
            return fuelType.toLowerCase().includes("adblue");
        },
        selectedEmployeeTckn() {
            if (!this.isAdBlue || !this.form.adblueCarrier.fullName) return null;

            const employee = this.employees.find((emp) => emp.FullName === this.form.adblueCarrier.fullName);
            return employee ? employee.IdentityNumber : null;
        },
    },
    methods: {
        initializePage() {
            this.loading = true;
            const id = this.$route.params.id;

            const listPromises = [FuelStorageApi.FuelOrder.ListForDocumentation(), FuelStorageApi.FuelStorage.List(), EmployeeOperationsApi.Employee.List(), VehicleOperationsApi.Plate.ListAll()];

            if (id) {
                FuelStorageApi.FuelOrder.Get(id)
                    .then((detailRes) => {
                        if (detailRes.data.Success) {
                            const orderDetails = detailRes.data.Data;
                            this.populateFormWithOrderDetails(orderDetails);
                            this.form.orderId = id;

                            Promise.all(listPromises).then((responses) => {
                                const [orderRes, storageRes, employeeRes, plateRes] = responses;

                                if (orderRes.data.Success) {
                                    const orders = orderRes.data.Data || [];
                                    this.fuelOrderOptions = orders.map((o) => ({
                                        ...o,
                                        displayText: `${o.OrderNumber} - ${o.FuelOrderBranch} (Toplam: ${o.OrderQuantityStr} L)`,
                                    }));
                                }
                                if (storageRes.data.Success) this.fuelStorageOptions = storageRes.data.Data || [];
                                if (employeeRes.data.Success) this.allEmployees = employeeRes.data.Data || [];
                                if (plateRes.data.Success) this.allPlates = plateRes.data.Data || [];

                                const orderExists = this.fuelOrderOptions.some((o) => o.Id === id);
                                if (!orderExists) {
                                    this.fuelOrderOptions.push({
                                        ...orderDetails,
                                        displayText: `${orderDetails.OrderNumber} - ${orderDetails.FuelOrderBranch} (Toplam: ${orderDetails.OrderQuantityStr} L)`,
                                    });
                                }
                            });

                            this.checkAndLoadExistingDocument(id);
                            this.fetchTransactionDetails(id);
                        } else {
                            this.$result(detailRes);
                            this.loading = false;
                        }
                    })
                    .catch((err) => {
                        this.$result(null, "Ana sipariş detayı yüklenirken hata oluştu.");
                        this.loading = false;
                    });
            } else {
                Promise.all(listPromises)
                    .then((responses) => {
                        const [orderRes, storageRes, employeeRes, plateRes] = responses;

                        if (orderRes.data.Success) {
                            const orders = orderRes.data.Data || [];
                            this.fuelOrderOptions = orders.map((o) => ({
                                ...o,
                                displayText: `${o.OrderNumber} - ${o.FuelOrderBranch} (Toplam: ${o.OrderQuantityStr} L)`,
                            }));
                        }
                        if (storageRes.data.Success) this.fuelStorageOptions = storageRes.data.Data || [];
                        if (employeeRes.data.Success) this.allEmployees = employeeRes.data.Data || [];
                        if (plateRes.data.Success) this.allPlates = plateRes.data.Data || [];
                    })
                    .catch((err) => {
                        this.$result(null, "Sayfa verileri yüklenirken bir hata oluştu.");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        checkAndLoadExistingDocument(orderId) {
            this.loading = true;
            FuelStorageApi.FuelOrderDetail.GetByFuelOrderId(orderId)
                .then((res) => {
                    if (res.data.Success && res.data.Data) {
                        this.editing = true;
                        this.documentDetailId = res.data.Data.Id;
                        this.populateFormWithExistingDetails(res.data.Data);
                        this.$toast.info("Bu siparişe ait daha önce işlenmiş evrak bilgileri yüklendi.", { position: "bottom-right" });
                    } else {
                        this.editing = false;
                        this.documentDetailId = null;
                    }
                })
                .catch((err) => {
                    this.editing = false;
                    this.documentDetailId = null;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getTruckPlates() {
            VehicleOperationsApi.Plate.ListTruck()
                .then((response) => {
                    if (response.data.Success) {
                        this.truckPlates = response.data.Data || [];
                    }
                })
                .catch((err) => console.error("Çekici plakaları yüklenemedi:", err));
        },

        getTrailerPlates() {
            VehicleOperationsApi.Plate.ListTrailer()
                .then((response) => {
                    if (response.data.Success) {
                        this.trailerPlates = response.data.Data || [];
                    }
                })
                .catch((err) => console.error("Treyler plakaları yüklenemedi:", err));
        },

        searchEmployees(search) {
            if (search && search.length >= 2) {
                this.employeeLoading = true;
                EmployeeOperationsApi.Employee.SearchActiveDriver(search)
                    .then((res) => {
                        if (res.data.Success) {
                            this.employees = res.data.Data || [];
                        }
                        this.employeeLoading = false;
                    })
                    .catch((err) => {
                        this.employeeLoading = false;
                    });
            }
        },
        populateFormWithExistingDetails(details) {
            const form = this.form;

            // Tedarikçi
            form.supplier.orderNumber = details.SupplierOrderNumber;
            form.supplier.locationId = details.SupplierLocationId;

            // Sürücü
            form.driver.destinationLocation = details.DriverDestinationLocation;

            // Kantar 1
            form.weighing1.firmId = details.WeighingFirm1Id;
            this.weighingFirm1Name = details.WeighingFirm1Name;
            form.weighing1.documentNumber = details.WeighingFirm1DocumentNumber;
            form.weighing1.startDate = details.WeighingFirm1StartDate;
            form.weighing1.endDate = details.WeighingFirm1EndDate;
            form.weighing1.timeZone = details.WeighingFirm1TimeZone;
            form.weighing1.weightValue1 = details.WeighingFirm1WeightValue1;
            form.weighing1.weightValue2 = details.WeighingFirm1WeightValue2;
            form.weighing1.file = details.Kantar1File;

            // Kantar 2
            form.weighing2.firmId = details.WeighingFirm2Id;
            this.weighingFirm2Name = details.WeighingFirm2Name;
            form.weighing2.documentNumber = details.WeighingFirm2DocumentNumber;
            form.weighing2.startDate = details.WeighingFirm2StartDate;
            form.weighing2.endDate = details.WeighingFirm2EndDate;
            form.weighing2.timeZone = details.WeighingFirm2TimeZone;
            form.weighing2.weightValue1 = details.WeighingFirm2WeightValue1;
            form.weighing2.weightValue2 = details.WeighingFirm2WeightValue2;
            form.weighing2.file = details.Kantar2File;

            // Teslimat Detayları
            this.form.deliverySlip.tankNumber = details.DeliverySlipTankNumber;
            this.form.deliverySlip.slipOrder = details.DeliverySlipOrder;
            this.form.deliverySlip.slipTime = details.DeliverySlipTime;
            this.form.deliverySlip.counterOpening = details.DeliverySlipCounterOpeningValue;
            this.form.deliverySlip.counterClosing = details.DeliverySlipCounterClosingValue;
            this.form.deliverySlip.additiveValue = details.DeliverySlipAdditiveValue;

            // e-İrsaliye
            form.eWaybill.number = details.EWaybillNumber;
            form.eWaybill.date = details.EWaybillDate;
            form.eWaybill.dispatchTime = details.DispatchTime;
            form.eWaybill.ltValue = details.TransportLtValue;
            form.eWaybill.kgValue = details.TransportKgValue;
            form.eWaybill.sealNumbers = details.SealNumbers;
            form.eWaybill.witnessSampleSerialNo = details.WitnessSampleSerialNo;
            form.eWaybill.file = details.IrsaliyeFile;

            // Teslim Tesellüm
            form.deliveryReceipt.reportDeliveryDate = details.ReportDeliveryDate;
            form.deliveryReceipt.file = details.TeslimatFile;

            // Analiz
            form.analysis.temperature = details.TemperatureValue;
            form.analysis.density = details.FuelDensityValue;
            form.analysis.setan = details.SetanNumber;
            form.analysis.sulfur = details.SulfurValue;
            form.analysis.fame = details.FameValue;
            form.analysis.flashPoint = details.FlashPointValue;
            form.analysis.file = details.LabFile;

            if (details.WeighingFirm2Id) {
                this.isWeighing2Visible = true;
            } else {
                this.isWeighing2Visible = false;
            }

            if (details.AdblueCarrierFullName) {
                if (!this.employees.find((e) => e.FullName === details.AdblueCarrierFullName)) {
                    this.employees.push({ FullName: details.AdblueCarrierFullName, Id: null });
                }
                this.form.adblueCarrier.fullName = details.AdblueCarrierFullName;
            }
            this.form.adblueCarrier.vehiclePlate = details.AdblueCarrierVehiclePlate || null;
            this.form.adblueCarrier.trailerPlate = details.AdblueCarrierVehicleTrailerPlate || null;
        },
        preparePayload() {
            const form = this.form;

            const plainData = {
                FuelOrderId: form.orderId,
                SupplierOrderNumber: form.supplier.orderNumber,
                SupplierLocationId: form.supplier.locationId,
                DriverDestinationLocation: form.driver.destinationLocation,

                WeighingFirm1Id: form.weighing1.firmId,
                WeighingFirm1DocumentNumber: form.weighing1.documentNumber,
                WeighingFirm1StartDate: form.weighing1.startDate ? new Date(form.weighing1.startDate).toISOString() : null,
                WeighingFirm1EndDate: form.weighing1.endDate ? new Date(form.weighing1.endDate).toISOString() : null,
                WeighingFirm1TimeZone: form.weighing1.timeZone,
                WeighingFirm1WeightValue1: Number(form.weighing1.weightValue1) || 0,
                WeighingFirm1WeightValue2: Number(form.weighing1.weightValue2) || 0,

                WeighingFirm2Id: form.weighing2.firmId,
                WeighingFirm2DocumentNumber: form.weighing2.documentNumber,
                WeighingFirm2StartDate: form.weighing2.startDate ? new Date(form.weighing2.startDate).toISOString() : null,
                WeighingFirm2EndDate: form.weighing2.endDate ? new Date(form.weighing2.endDate).toISOString() : null,
                WeighingFirm2TimeZone: form.weighing2.timeZone,
                WeighingFirm2WeightValue1: Number(form.weighing2.weightValue1) || 0,
                WeighingFirm2WeightValue2: Number(form.weighing2.weightValue2) || 0,

                DeliverySlipTankNumber: form.deliverySlip.tankNumber,
                DeliverySlipOrder: form.deliverySlip.slipOrder,
                DeliverySlipTime: form.deliverySlip.slipTime ? new Date(form.deliverySlip.slipTime).toISOString() : null,
                DeliverySlipCounterOpeningValue: Number(form.deliverySlip.counterOpening) || 0,
                DeliverySlipCounterClosingValue: Number(form.deliverySlip.counterClosing) || 0,
                DeliverySlipAdditiveValue: Number(form.deliverySlip.additiveValue) || 0,

                EWaybillNumber: form.eWaybill.number,
                EWaybillDate: form.eWaybill.date ? new Date(form.eWaybill.date).toISOString() : null,
                DispatchTime: form.eWaybill.dispatchTime ? new Date(form.eWaybill.dispatchTime).toISOString() : null,
                TransportLtValue: Number(form.eWaybill.ltValue) || 0,
                TransportKgValue: Number(form.eWaybill.kgValue) || 0,
                SealNumbers: form.eWaybill.sealNumbers,
                WitnessSampleSerialNo: form.eWaybill.witnessSampleSerialNo,

                ReportDeliveryDate: form.deliveryReceipt.reportDeliveryDate ? new Date(form.deliveryReceipt.reportDeliveryDate).toISOString() : null,

                TemperatureValue: Number(form.analysis.temperature) || 0,
                FuelDensityValue: Number(form.analysis.density) || 0,
                SetanNumber: Number(form.analysis.setan) || 0,
                SulfurValue: Number(form.analysis.sulfur) || 0,
                FameValue: Number(form.analysis.fame) || 0,
                FlashPointValue: Number(form.analysis.flashPoint) || 0,

                AdblueCarrierFullName: this.isAdBlue ? form.adblueCarrier.fullName || null : null,
                AdblueCarrierVehiclePlate: this.isAdBlue ? form.adblueCarrier.vehiclePlate || null : null,
                AdblueCarrierVehicleTrailerPlate: this.isAdBlue ? form.adblueCarrier.trailerPlate || null : null,
            };

            if (this.editing) {
                plainData.Id = this.documentDetailId;
            }

            const formData = new FormData();

            Object.keys(plainData).forEach((key) => {
                if (plainData[key] !== null && plainData[key] !== undefined) {
                    formData.append(key, plainData[key]);
                }
            });

            if (form.eWaybill.file instanceof File) formData.append("IrsaliyeFile", form.eWaybill.file);
            if (form.weighing1.file instanceof File) formData.append("Kantar1File", form.weighing1.file);
            if (form.weighing2.file instanceof File) formData.append("Kantar2File", form.weighing2.file);
            if (form.deliveryReceipt.file instanceof File) formData.append("TeslimatFile", form.deliveryReceipt.file);
            if (form.analysis.file instanceof File) formData.append("LabFile", form.analysis.file);

            return formData;
        },
        formatDensity(n) {
            const numberValue = n == null || isNaN(n) ? 0 : n;
            return new Intl.NumberFormat("tr-TR", {
                minimumFractionDigits: 4,
                maximumFractionDigits: 4,
            }).format(numberValue);
        },
        onDensityFocus() {
            const value = this.form.analysis.density;
            if (value === null) {
                this.displayValues.density = "";
            } else {
                this.displayValues.density = String(value).replace(".", ",");
            }
        },
        onDensityBlur() {
            const rawValue = this.displayValues.density.toString().trim();
            let newValue;

            if (rawValue === "") {
                newValue = null;
            } else {
                const parsedValue = parseFloat(rawValue.replace(",", "."));
                if (isNaN(parsedValue)) {
                    newValue = null;
                } else {
                    newValue = parsedValue;
                }
            }

            this.form.analysis.density = newValue;
            this.displayValues.density = this.formatDensity(newValue);
        },
        validateForm() {
            this.errors = {};

            if (!this.form.orderId) this.$set(this.errors, "orderId", "Ana Sipariş seçimi zorunludur.");
            if (!this.form.supplier.locationId) this.$set(this.errors, "supplier.locationId", "Tedarikçi konumu seçilmelidir.");

            if (!this.form.weighing1.firmId) this.$set(this.errors, "weighing1.firmId", "Firma seçimi zorunludur.");
            if (!this.form.weighing1.documentNumber) this.$set(this.errors, "weighing1.documentNumber", "Fiş no girilmelidir.");
            if (!this.form.weighing1.weightValue1 || this.form.weighing1.weightValue1 <= 0) this.$set(this.errors, "weighing1.weightValue1", "Tartım-1 değeri girilmelidir.");
            if (!this.form.weighing1.weightValue2 || this.form.weighing1.weightValue2 <= 0) this.$set(this.errors, "weighing1.weightValue2", "Tartım-2 değeri girilmelidir.");
            if (!this.form.weighing1.startDate) this.$set(this.errors, "weighing1.startDate", "Giriş tarihi zorunludur.");
            if (!this.form.weighing1.endDate) this.$set(this.errors, "weighing1.endDate", "Çıkış tarihi zorunludur.");

            const w1 = this.form.weighing1.weightValue1 || 0;
            const w2 = this.form.weighing1.weightValue2 || 0;
            if (w1 > 0 && w2 > w1) {
                this.$set(this.errors, "weighing1.weightValue2", "Boş ağırlık, dolu ağırlıktan fazla olamaz.");
            }

            if (this.form.weighing1.startDate && this.form.weighing1.endDate && new Date(this.form.weighing1.startDate) > new Date(this.form.weighing1.endDate)) {
                this.$set(this.errors, "weighing1.endDate", "Çıkış tarihi, giriş tarihinden önce olamaz.");
            }

            if (!this.form.analysis.density || this.form.analysis.density <= 0) this.$set(this.errors, "analysis.density", "Yoğunluk değeri zorunludur.");

            if (!this.form.eWaybill.number) this.$set(this.errors, "eWaybill.number", "e-İrsaliye no girilmelidir.");
            if (!this.form.eWaybill.date) this.$set(this.errors, "eWaybill.date", "İrsaliye tarihi seçilmelidir.");
            if (!this.form.eWaybill.dispatchTime) this.$set(this.errors, "eWaybill.dispatchTime", "Sevk zamanı seçilmelidir.");
            if (!this.form.eWaybill.ltValue || this.form.eWaybill.ltValue <= 0) this.$set(this.errors, "eWaybill.ltValue", "Miktar (lt) girilmelidir.");

            if (!this.form.deliveryReceipt.reportDeliveryDate) this.$set(this.errors, "deliveryReceipt.reportDeliveryDate", "Teslimat zamanı seçilmelidir.");

            if (this.isAdBlue) {
                if (!this.form.adblueCarrier.fullName) this.$set(this.errors, "adblueCarrier.fullName", "Sürücü seçimi zorunludur.");

                if (!this.form.adblueCarrier.vehiclePlate) this.$set(this.errors, "adblueCarrier.vehiclePlate", "Çekici plakası zorunludur.");
            }

            return Object.keys(this.errors).length === 0;
        },
        save() {
            if (!this.validateForm()) {
                this.$toast.error("Lütfen işaretli zorunlu alanları doldurun.", {
                    position: "bottom-right",
                    toastClassName: "danger",
                });
                return;
            }
            this.loading = true;
            const payload = this.preparePayload();

            const request = this.editing ? FuelStorageApi.FuelOrderDetail.Update(payload) : FuelStorageApi.FuelOrderDetail.Create(payload);

            request
                .then((res) => {
                    this.$result(res);
                    if (res.data.Success) {
                        this.$router.push({ name: "fuel-storage-order" });
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        fetchTransactionDetails(orderId) {
            if (!orderId) {
                this.transactionDetails = [];
                return;
            }

            const datatablePayload = {
                orderId: orderId,
                PaginationRequestModel: { Page: 1, PageSize: 100 },
            };

            FuelStorageApi.FuelStorageTransaction.Datatable(datatablePayload)
                .then((res) => {
                    if (res.data.Success) {
                        this.transactionDetails = res.data.Data.Data || [];
                    } else {
                        this.transactionDetails = [];
                    }
                })
                .catch((err) => {
                    console.error("Transaction detayları çekilirken hata:", err);
                    this.transactionDetails = [];
                });
        },
        populateFormWithOrderDetails(details) {
            this.selectedOrder = {
                supplierName: details.Supplier,
                supplierId: details.SupplierId,
                orderNumber: details.OrderNumber,
                orderQuantity: details.OrderQuantity,
                fuelTypeName: details.FuelTypeName,
                vehiclePlate: details.VehiclePlate,
                vehiclePlateId: details.VehiclePlateId,
                trailerPlate: details.TrailerPlate,
                driverEmployee: details.DriverEmployee,
                driverEmployeeId: details.DriverEmployeeId,
                fuelOrderBranchId: details.FuelOrderBranchId,
                remainingOrderQuantity: details.RemainingOrderQuantity,
                orderDate: details.OrderDate,
                vade: details.Vade,
                unitPrice: details.UnitPrice,
                transportAmount: details.TransportAmount,
            };
            this.form.driver.destinationLocation = details.FuelOrderBranch;

            if (details.SupplierId) {
                this.getSupplierLocations(details.SupplierId);
            }
        },
        getEmployeeName(employeeId) {
            if (!employeeId || !this.allEmployees.length) return "N/A";
            const employee = this.allEmployees.find((emp) => emp.Id === employeeId);
            return employee ? employee.FullName : "Bulunamadı";
        },
        getPlateValue(plateId) {
            if (!plateId || !this.allPlates.length) return "N/A";
            const plate = this.allPlates.find((p) => p.Id === plateId);
            return plate ? plate.PlateValue : "Bulunamadı";
        },
        getSupplierLocations(firmId) {
            if (!firmId) {
                this.supplierLocations = [];
                this.form.supplier.locationId = null;
                return;
            }
            this.locationsLoading = true;
            FirmOperationsApi.Location.List(firmId)
                .then((res) => {
                    if (res.data.Success) {
                        this.supplierLocations = res.data.Data || [];
                    }
                })
                .catch((err) => this.$result(null, "Tedarikçi konumları yüklenemedi."))
                .finally(() => {
                    this.locationsLoading = false;
                });
        },
        getCurrentUser() {
            UserApi.CurrentUserProfile()
                .then((res) => {
                    if (res.data.Success && res.data.Data) {
                        const user = res.data.Data;
                        this.form.deliveryReceipt.receiverFullName = `${user.FirstName} ${user.LastName}`;
                    }
                })
                .catch((err) => {
                    console.error("Mevcut kullanıcı bilgisi alınamadı:", err);
                    this.$result(null, "Teslim alan bilgisi otomatik olarak getirilemedi.");
                });
        },
        disableReportDeliveryDates(date) {
            if (this.form.eWaybill.dispatchTime) {
                const dispatchDate = new Date(this.form.eWaybill.dispatchTime);
                dispatchDate.setHours(0, 0, 0, 0);
                return date < dispatchDate;
            }
            return false;
        },
        disableReportDeliveryTimes(date) {
            if (this.form.eWaybill.dispatchTime) {
                const dispatchDate = new Date(this.form.eWaybill.dispatchTime);
                if (date.toDateString() === dispatchDate.toDateString()) {
                    return date.getTime() < dispatchDate.getTime();
                }
            }
            return false;
        },

        disableDispatchDates(date) {
            if (this.form.deliveryReceipt.reportDeliveryDate) {
                const reportDate = new Date(this.form.deliveryReceipt.reportDeliveryDate);
                reportDate.setHours(0, 0, 0, 0);
                return date > reportDate;
            }
            return false;
        },
        disableDispatchTimes(date) {
            if (this.form.deliveryReceipt.reportDeliveryDate) {
                const reportDate = new Date(this.form.deliveryReceipt.reportDeliveryDate);
                if (date.toDateString() === reportDate.toDateString()) {
                    return date.getTime() > reportDate.getTime();
                }
            }
            return false;
        },
        calculatedWeight(quantity) {
            const density = this.form.analysis.density || 0;
            return (quantity * density).toFixed(2);
        },
        onOrderSelect(orderId) {
            if (!orderId) {
                this.form = getInitialFormData();
                this.selectedOrder = { orderDate: null };
                this.supplierLocations = [];
                this.checkAndLoadExistingDocument(null);
                this.fetchTransactionDetails(null);
                this.isWeighing2Visible = false;
                return;
            }
            this.loading = true;
            FuelStorageApi.FuelOrder.Get(orderId)
                .then((res) => {
                    if (res.data.Success) {
                        this.populateFormWithOrderDetails(res.data.Data);
                        this.fetchTransactionDetails(orderId);
                        this.checkAndLoadExistingDocument(orderId);
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped>
.sticky-top {
    top: 10px;
    background-color: white;
    z-index: 1;
}
.summary-box-primary {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    min-height: 60px;
    border-radius: 0.35rem;
    background-color: #007bff;
    color: white;
    transition: background-color 0.3s ease;
}
.summary-box-primary span {
    font-size: 0.75rem;
    opacity: 0.8;
}
.summary-box-primary strong {
    font-size: 1.1rem;
}
.summary-box-success {
    background-color: #28a745 !important;
}
.summary-box-danger {
    background-color: #dc3545 !important;
}
.summary-box-secondary {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    min-height: 60px;
    border-radius: 0.35rem;
    background-color: #f3f2f7;
    border: 1px solid #ebe9f1;
    color: #5e5873;
}
.summary-box-secondary span {
    font-size: 0.75rem;
    opacity: 0.8;
}
.summary-box-secondary strong {
    font-size: 1.1rem;
}
.is-required >>> .col-form-label::after,
.is-required /deep/ .col-form-label::after {
    content: " *";
    color: #dc3545;
    font-weight: 700;
}
</style>
